import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXlsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18.305,
	height: 22.02,
	viewBox: "0 0 18.305 22.02",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "xls-icon",
		transform: "translate(-229 -431)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "icon-back",
			transform: "translate(229 431)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "back-shape",
					d: "M31.276,1.685H21.5a1.282,1.282,0,0,0-1.282,1.282V22.423A1.282,1.282,0,0,0,21.5,23.7H35.41a1.282,1.282,0,0,0,1.282-1.282V7.1Z",
					transform: "translate(-18.387 -1.685)",
					fill: "#f7f6f8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner-shadow",
					d: "M160.554,61.4h3.74v3.74Z",
					transform: "translate(-145.99 -55.98)",
					fill: "#eae9ec"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "corner",
					d: "M142.07,1.685V5.82a1.3,1.3,0,0,0,1.3,1.282h4.117Z",
					transform: "translate(-129.182 -1.685)",
					fill: "#d7d6db"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "block_shadow",
					"data-name": "block shadow",
					d: "M34.917,129.774v-7.125a.58.58,0,0,0-.58-.58H20.221v8.285H34.337a.58.58,0,0,0,.58-.58",
					transform: "translate(-18.387 -111.149)",
					fill: "#dee2e6"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "color_block",
					"data-name": "color block",
					d: "M15.95,125.635H.58a.649.649,0,0,1-.58-.7v-8.6a.649.649,0,0,1,.58-.7H15.95a.649.649,0,0,1,.58.7v8.6a.649.649,0,0,1-.58.7",
					transform: "translate(0 -107.299)",
					fill: "#257d44"
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_3133",
			"data-name": "Path 3133",
			d: "M-5.88,0h.609a.379.379,0,0,0,.413-.287,9.972,9.972,0,0,1,.875-1.582A10.561,10.561,0,0,1-3.108-.287.372.372,0,0,0-2.7,0h.686c.168,0,.252-.077.252-.217A7.022,7.022,0,0,0-3.171-2.576,7.022,7.022,0,0,0-1.764-4.935c0-.14-.084-.217-.252-.217h-.6c-.231,0-.315.07-.42.287a10.521,10.521,0,0,1-.868,1.582,10.561,10.561,0,0,1-.875-1.582c-.1-.217-.182-.287-.413-.287H-5.88c-.161,0-.245.077-.245.217A6.9,6.9,0,0,0-4.718-2.576,6.9,6.9,0,0,0-6.125-.217C-6.125-.077-6.041,0-5.88,0Zm5.1,0H1.806c.2,0,.28-.084.28-.287v-.5c0-.2-.077-.287-.28-.287H.119V-4.865c0-.2-.077-.287-.28-.287H-.777c-.2,0-.28.084-.28.287V-.287C-1.057-.084-.973,0-.777,0Zm4.76.077c1.127,0,2.009-.462,2.009-1.512a1.45,1.45,0,0,0-1.134-1.5L4.438-3.1c-.483-.182-.644-.357-.644-.623,0-.315.252-.462.707-.462a3.293,3.293,0,0,1,.945.161c.2.07.294.021.343-.168l.1-.448c.042-.21-.021-.308-.224-.378a3.436,3.436,0,0,0-1.176-.21c-1.19,0-1.939.518-1.939,1.491A1.482,1.482,0,0,0,3.682-2.219l.42.154c.483.182.651.357.651.616,0,.308-.238.483-.777.483a4.03,4.03,0,0,1-1.155-.189c-.245-.077-.329.007-.329.217v.5a.3.3,0,0,0,.245.329A3.989,3.989,0,0,0,3.983.077Z",
			transform: "translate(237.29 446.999)",
			fill: "#fff"
		})]
	})
});
export default SvgXlsIcon;
